import ClientService from "./client.service";
export default class ClientLoginService extends ClientService {
  template = "LoginTemplate";
  icon = "ThreeUserx";
}
